import { useRef, useCallback } from 'react';
import useUpdate from './useUpdate';
var useGetSet = function (initialValue) {
    var state = useRef(initialValue);
    var update = useUpdate();
    var get = useCallback(function () { return state.current; }, []);
    var set = useCallback(function (value) {
        state.current = value;
        update();
    }, []);
    return [get, set];
};
export default useGetSet;
